<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/178Q8I9/tc-custom/9781952871344.jpg?1688964719094" alt="This image is the cover for the book Unconventional Love Box Set"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unconventional Love Box Set
      </h1>
      <p class="bookDescription body article font2">
        <b>WAS IT GOOD FOR YOU TOO? </b><br/><br/>Tailan and Delvin complicated their lives by bringing another woman into the relationship to bear his children. Once the surrogate was two months along, she turned the tables by issuing a heartbreaking ultimatum. Now seven years later on a Midwest book tour, fate has given Delvin, now a wealthy actor and author, four days to right old wrongs. He’ll use everything in his power to win Tailan back. Unfortunately, Tailan is harboring a secret that she’s kept not only from him but from the entire world. <br/><br/> <b>OPEN DOOR MARRIAGE</b><br/><br/>USA TODAY Bestselling Author, Naleighna Kai, tells the dynamic love triangle of a chance encounter that lands wealthy NBA star, Dallas Avery, back in the arms of Alicia, the woman of his dreams. A woman he hasn’t seen in years. A woman he soon discovers is his fiancée’s long-lost aunt! <br/><br/>But Tori, isn’t ready to give up all that she’s worked for in their relationship, so she makes him a shocking offer—go through with the wedding and she’ll still allow him to be with the one woman he now can’t seem to do without. Everyone will get a little of what they want. . . and maybe a whole lot of what they don’t. <br/><br/><b>RICH WOMAN’S FETISH</b><br/><br/>Gina learns that one of her surrogate daughters has been forced into the illicit world of drugs and prostitution. When the police and FBI turn a blind eye, Gina risks the anger of her former sponsors and lovers to have their children search for the younger sister they know nothing about. One daughter turns to a criminal mastermind to help locate the teen; another puts her career in jeopardy when she seeks justice in her own deadly way. If exploring the darker underworld of the lengths couples will go to have a child, and the sensual journey that one woman takes to survive makes you even slightly curious, then you’ll love USA TODAY Bestselling Author Naleighna Kai’s Rich Woman’s Fetish.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Naleighna Kai
      </h2>
      
      <p class="authorDescription body article"><i><b>Naleighna Kai is the USA TODAY and Essence® national bestselling and award-winning author<i></b> of several women's fiction, contemporary fiction, Christian fiction, Romance, Suspense, and Science Fiction novels that plumb the depth of unique relationships and women's issues. She is also a contributor to a New York Times bestseller, one of AALBC's 100 Top Authors, a member of the Chicago Vocational School (CVS) Hall of Fame, Mercedes Benz Mentor Award Nominee, and the E. Lynn Harris Author of Distinction. Visit her on the web at www.naleighnakai.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macro Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?006104d4